<template>
  <v-app-bar class="" style="height: 96px;" app dark>
    <v-row justify="center" class="white--text text-decoration-none text-center text-h4 font-weight-bold pt-12" >
      <!-- <v-col col="6"> -->
      <img alt="logo" class="ebc-logo  mx-5" :src="require('../assets/ebc-logo.svg')" width="120" />
    <!-- </v-col>
    <v-col col="6"> -->
      <p class="white--text text-decoration-none text-center text-h4 font-weight-bold mt-4">Pago Transferencia (BBVA o SPEI)</p>
    <!-- </v-col> -->
    </v-row>
  </v-app-bar>
</template>

<script>

export default {
  name: "Navbar",
};
</script>

<style lang="scss" scoped>
.ebc-logo {
  filter: brightness(0) invert(1);
  // margin-right: 30px;
  // margin-left: 50px;
}

.theme--dark.v-app-bar.v-toolbar.v-sheet {
  background-color: #000000;
}
</style>
